// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/*Copyright (c) 2025 por Tecnologías de Información MALMUR y empresas afiliadas. Todos los derechos reservados.
Este software es información confidencial y propietaria de Copyright (c) 2025 por Tecnologías de Información MALMUR
 y sus afiliadas. ("Información Confidencial"). Usted no puede divulgar dicha Información Confidencial, 
 y solo puede usar dicha Información Confidencial de acuerdo con los términos del acuerdo de licencia que celebró con MALMUR.*/
/*Copyright (c) 2025 by Tecnologías de Información MALMUR and affiliated companies. All Rights Reserved.
This software is confidential and proprietary information of Copyright (c) 2025 by Tecnologías de Información 
MALMUR and its affiliates. ("Confidential Information"). You may not disclose such Confidential Information, 
and may only use such Confidential Information in accordance with the terms of the license agreement you entered 
into with MALMUR.*/
/*Copyright (c) 2025 por Tecnologías de Información MALMUR y empresas afiliadas. Todos los derechos reservados.
Este software es información confidencial y propietaria de Copyright (c) 2025 por Tecnologías de Información MALMUR
 y sus afiliadas. ("Información Confidencial"). Usted no puede divulgar dicha Información Confidencial, 
 y solo puede usar dicha Información Confidencial de acuerdo con los términos del acuerdo de licencia que celebró con MALMUR.*/
/*Copyright (c) 2025 by Tecnologías de Información MALMUR and affiliated companies. All Rights Reserved.
This software is confidential and proprietary information of Copyright (c) 2025 by Tecnologías de Información 
MALMUR and its affiliates. ("Confidential Information"). You may not disclose such Confidential Information, 
and may only use such Confidential Information in accordance with the terms of the license agreement you entered 
into with MALMUR.*/
.notification-widget {
  max-width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  padding-left: 0;
  padding-right: 0;
}
.notification-widget--light {
  border-radius: 24px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  background: linear-gradient(145deg, #ffffff 0%, #f8fafc 100%);
}

.notification-widget-header {
  padding: 24px;
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
}
.notification-widget-header--light {
  background: linear-gradient(135deg, #1a1a1a 0%, #2d2d2d 100%);
  color: #ffffff;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
}
.notification-widget-header--dark {
  background: linear-gradient(135deg, #2d2d2d 0%, #1a1a1a 100%);
  color: #ffffff;
}

.notification-widget-header-title {
  font-size: 1rem !important;
  font-weight: 700 !important;
}
.notification-widget-header-title--light {
  color: #ffffff;
}

.notification-widget-header-badge--light .MuiBadge-badge {
  background-color: #ff4757;
  color: white;
  font-weight: 600;
}

.notification-widget-header-icon--light {
  color: #ffffff !important;
}

.notification-widget-header-button {
  font-size: 0.75rem !important;
}
.notification-widget-header-button--light {
  color: #ffffff;
  border-color: rgba(255, 255, 255, 0.3);
  background-color: rgba(255, 255, 255, 0.1);
}
.notification-widget-header-button--light:hover {
  background-color: rgba(255, 255, 255, 0.2);
  border-color: rgba(255, 255, 255, 0.5);
}
.notification-widget-header-button--dark {
  color: white;
  border-color: rgba(255, 255, 255, 0.3);
  background-color: rgba(0, 0, 0, 0.1);
}
.notification-widget-header-button--dark:hover {
  background-color: rgba(0, 0, 0, 0.2);
  border-color: rgba(255, 255, 255, 0.5);
}

.notification-widget-header-caption {
  font-size: 0.875rem !important;
  font-weight: 500 !important;
}
.notification-widget-header-caption--light {
  color: #ffffff;
  opacity: 1;
}
.notification-widget-header-caption--dark {
  color: #ffffff;
  opacity: 0.9;
}

.notification-widget-stats-box {
  margin-top: 16px;
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

.notification-widget-toggle-read:focus, .notification-widget-toggle-read:focus-visible, .notification-widget-toggle-read:active {
  background-color: rgba(128, 128, 128, 0.1) !important;
  outline: none !important;
}
.notification-widget-toggle-read {
  font-size: 0.875rem !important;
}

.notification-widget-stats-chip {
  font-weight: 600 !important;
  cursor: pointer;
  transition: all 0.2s ease;
}
.notification-widget-stats-chip:hover {
  transform: scale(1.05);
  opacity: 0.9;
}
.notification-widget-stats-chip--active {
  border: 2.5px solid #575757 !important;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.12);
  z-index: 1;
}
.notification-widget-stats-chip--total-light {
  background-color: rgba(201, 201, 201, 0.59) !important;
  color: #000000 !important;
}
.notification-widget-stats-chip--total-light .MuiChip-label {
  color: #000000 !important;
}
.notification-widget-stats-chip--total-light.notification-widget-stats-chip--active {
  background-color: rgba(201, 201, 201, 0.9) !important;
  border: 2.5px solid #000000 !important;
}
.notification-widget-stats-chip--total-dark {
  background-color: #1a2535 !important;
  color: #ffffff !important;
}
.notification-widget-stats-chip--total-dark .MuiChip-label {
  color: #ffffff !important;
}
.notification-widget-stats-chip--total-dark.notification-widget-stats-chip--active {
  background-color: rgba(255, 255, 255, 0.158) !important;
  border: 2.5px solid #fff !important;
}
.notification-widget-stats-chip--unread-light {
  background-color: #ff3546 !important;
  color: #000000 !important;
}
.notification-widget-stats-chip--unread-light .MuiChip-label {
  color: #000000 !important;
}
.notification-widget-stats-chip--unread-light.notification-widget-stats-chip--active {
  background-color: #ea3030 !important;
  border: 2.5px solid #000000 !important;
}
.notification-widget-stats-chip--unread-dark {
  background-color: #710800 !important;
  color: #ffffff !important;
}
.notification-widget-stats-chip--unread-dark .MuiChip-label {
  color: #ffffff !important;
}
.notification-widget-stats-chip--unread-dark.notification-widget-stats-chip--active {
  background-color: #7a4542 !important;
  border: 2.5px solid #fff !important;
}
.notification-widget-stats-chip--read-light {
  background-color: rgba(82, 205, 87, 0.8) !important;
  color: #000000 !important;
}
.notification-widget-stats-chip--read-light .MuiChip-label {
  color: #000000 !important;
}
.notification-widget-stats-chip--read-light.notification-widget-stats-chip--active {
  background-color: rgb(116, 248, 121) !important;
  border: 2.5px solid #000000 !important;
}
.notification-widget-stats-chip--read-dark {
  background-color: rgba(42, 128, 48, 0.6078431373) !important;
  color: #ffffff !important;
}
.notification-widget-stats-chip--read-dark .MuiChip-label {
  color: #ffffff !important;
}
.notification-widget-stats-chip--read-dark.notification-widget-stats-chip--active {
  background-color: rgba(105, 188, 111, 0.6078431373) !important;
  border: 2.5px solid #fff !important;
}

.notification-widget-item {
  cursor: pointer;
  border-radius: 8px;
  margin-top: 8px;
  margin-bottom: 8px;
  margin-left: 16px;
  margin-right: 16px !important;
  transition: all 0.2s ease;
}
.notification-widget-item.MuiListItem-root {
  padding-top: 16px !important;
  padding-bottom: 16px !important;
  padding-left: 16px !important;
  padding-right: 32px !important;
  margin-right: 16px !important;
}
.notification-widget-item .MuiListItemText-root {
  padding-right: 16px !important;
}
.notification-widget-item--read {
  opacity: 0.6;
}
.notification-widget-item--unread {
  opacity: 1;
}
.notification-widget-item:hover {
  opacity: 1;
}

.notification-widget-title {
  flex-grow: 1;
  font-size: 0.9375rem !important;
}
.notification-widget-title--read {
  font-weight: normal;
}
.notification-widget-title--unread {
  font-weight: bold !important;
}

.notification-widget-message {
  margin-bottom: 4px;
  font-size: 0.9375rem !important;
}

.notification-widget-date {
  font-size: 0.75rem !important;
  opacity: 0.7;
}

.notification-widget-divider {
  margin-top: 24px;
  margin-bottom: 20px;
  border: 0;
  border-top: 6px solid rgba(0, 0, 0, 0.18);
  position: relative;
  width: 100%;
  z-index: 0;
}
.notification-widget-divider--read {
  margin-bottom: 20px;
}
.notification-widget-divider--unread {
  margin-top: 24px;
  margin-bottom: 20px;
}

.notification-widget--light .notification-widget-divider {
  border-top: 6px solid #1a1a1a !important;
}

.notification-widget--dark .notification-widget-divider {
  border-top: 6px solid rgba(255, 255, 255, 0.22) !important;
}

.notification-widget-divider-chip {
  display: flex !important;
  justify-content: center !important;
  align-items: center !important;
  margin: 12px 0 20px 0 !important;
  width: 100% !important;
}
.notification-widget-divider-chip .MuiChip-root {
  display: inline-flex !important;
  background: none !important;
}

.notification-widget-item {
  margin-top: 8px;
}

.notification-widget-chip {
  opacity: 1 !important;
  font-size: 0.85rem !important;
  font-weight: 700 !important;
  background-color: transparent !important;
  align-self: center !important;
  align-content: center !important;
}
.notification-widget-chip--read .MuiChip-label {
  color: #4caf50 !important;
}
.notification-widget-chip--unread .MuiChip-label {
  color: #ff4757 !important;
}
.notification-widget-chip.MuiChip-label--light .MuiChip-label {
  color: #909090 !important;
}
.notification-widget-chip.MuiChip-label--dark .MuiChip-label {
  color: #ffffff !important;
}

.notification-widget-loading {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 32px;
}

.notification-widget-loading-text {
  margin-left: 16px;
}

.notification-widget-error {
  padding: 16px;
}

.notification-widget-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 32px;
}

.notification-widget-empty-icon {
  font-size: 48px;
  margin-bottom: 8px;
}

.notification-widget-empty-caption {
  margin-top: 8px;
}

.notification-widget-list {
  padding: 16px;
  max-height: 675px;
  overflow-y: auto;
  overflow-x: hidden;
}
.notification-widget-list .notification-widget-divider-chip {
  text-align: center;
  display: flex;
  justify-content: center;
}
.notification-widget-list::-webkit-scrollbar {
  width: 8px;
}
.notification-widget-list::-webkit-scrollbar-track {
  background: rgba(0, 0, 0, 0.05);
  border-radius: 4px;
}
.notification-widget-list::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.2);
  border-radius: 4px;
}
.notification-widget-list::-webkit-scrollbar-thumb:hover {
  background: rgba(0, 0, 0, 0.3);
}

.notification-widget-content {
  flex: 1 1 auto;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.notification-widget-snackbar .MuiSnackbarContent-root {
  border-radius: 8px;
  font-weight: 500;
}`, "",{"version":3,"sources":["webpack://./src/styles/components/_notifications.scss","webpack://./src/styles/_variables.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;;;8HAAA;AAKA;;;;kBAAA;ACLA;;;8HAAA;AAKA;;;;kBAAA;ADQA;EACE,eAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,eAAA;EACA,gBAAA;AAOF;AANE;EACE,mBAAA;EACA,0CAAA;EACA,6DAAA;AAQJ;;AAJA;EACE,aCCW;EDAX,4BAAA;EACA,6BAAA;AAOF;AANE;EACE,6DAAA;EACA,cAAA;EACA,yCAAA;AAQJ;AANE;EACE,6DAAA;EACA,cAAA;AAQJ;;AAJA;EACE,0BAAA;EACA,2BAAA;AAOF;AANE;EACE,cAAA;AAQJ;;AAHE;EACE,yBAAA;EACA,YAAA;EACA,gBAAA;AAMJ;;AADE;EACE,yBAAA;AAIJ;;AAAA;EACE,6BAAA;AAGF;AAFE;EACE,cAAA;EACA,sCAAA;EACA,0CAAA;AAIJ;AAHI;EACE,0CAAA;EACA,sCAAA;AAKN;AAFE;EACE,YAAA;EACA,sCAAA;EACA,oCAAA;AAIJ;AAHI;EACE,oCAAA;EACA,sCAAA;AAKN;;AAAA;EACE,8BAAA;EACA,2BAAA;AAGF;AAFE;EACE,cAAA;EACA,UAAA;AAIJ;AAFE;EACE,cAAA;EACA,YAAA;AAIJ;;AAAA;EACE,gBAAA;EACA,aAAA;EACA,QAAA;EACA,eAAA;AAGF;;AACE;EAGE,qDAAA;EACA,wBAAA;AAAJ;AALA;EAOE,8BAAA;AACF;;AAEA;EACE,2BAAA;EACA,eAAA;EACA,yBAAA;AACF;AAAE;EACE,sBAAA;EACA,YAAA;AAEJ;AAAE;EACE,sCAAA;EACA,yCAAA;EACA,UAAA;AAEJ;AAAE;EACE,sDAAA;EACA,yBAAA;AAEJ;AADI;EACE,yBAAA;AAGN;AADI;EACE,qDAAA;EACA,sCAAA;AAGN;AAAE;EACE,oCAAA;EACA,yBAAA;AAEJ;AADI;EACE,yBAAA;AAGN;AADI;EACE,uDAAA;EACA,mCAAA;AAGN;AAAE;EACE,oCAAA;EACA,yBAAA;AAEJ;AADI;EACE,yBAAA;AAGN;AADI;EACE,oCAAA;EACA,sCAAA;AAGN;AAAE;EACE,oCAAA;EACA,yBAAA;AAEJ;AADI;EACE,yBAAA;AAGN;AADI;EACE,oCAAA;EACA,mCAAA;AAGN;AAAE;EACE,mDAAA;EACA,yBAAA;AAEJ;AADI;EACE,yBAAA;AAGN;AADI;EACE,+CAAA;EACA,sCAAA;AAGN;AAAE;EACE,4DAAA;EACA,yBAAA;AAEJ;AADI;EACE,yBAAA;AAGN;AADI;EACE,8DAAA;EACA,mCAAA;AAGN;;AAEA;EACE,eAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,iBC9KW;ED+KX,6BAAA;EACA,yBAAA;AACF;AACE;EACE,4BAAA;EACA,+BAAA;EACA,6BAAA;EACA,8BAAA;EACA,6BAAA;AACJ;AAEE;EACE,8BAAA;AAAJ;AAEE;EACE,YAAA;AAAJ;AAEE;EACE,UAAA;AAAJ;AAEE;EACE,UAAA;AAAJ;;AAIA;EACE,YAAA;EACA,+BAAA;AADF;AAEE;EACE,mBAAA;AAAJ;AAEE;EACE,4BAAA;AAAJ;;AAIA;EACE,kBAAA;EACA,+BAAA;AADF;;AAGA;EACE,6BAAA;EACA,YAAA;AAAF;;AAEA;EACE,gBAAA;EACA,mBAAA;EACA,SAAA;EACA,yCAAA;EACA,kBAAA;EACA,WAAA;EACA,UAAA;AACF;AACE;EACE,mBAAA;AACJ;AACE;EACE,gBAAA;EACA,mBAAA;AACJ;;AAGA;EACE,wCAAA;AAAF;;AAEA;EACE,0DAAA;AACF;;AAEA;EACE,wBAAA;EACA,kCAAA;EACA,8BAAA;EACA,gCAAA;EACA,sBAAA;AACF;AACE;EACE,+BAAA;EACA,2BAAA;AACJ;;AAGA;EACE,eAAA;AAAF;;AAIA;EACE,qBAAA;EACA,6BAAA;EACA,2BAAA;EACA,wCAAA;EACA,6BAAA;EACA,gCAAA;AADF;AAEE;EACE,yBAAA;AAAJ;AAGE;EACE,yBAAA;AADJ;AAIE;EACE,yBAAA;AAFJ;AAKE;EACE,yBAAA;AAHJ;;AAOA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;AAJF;;AAOA;EACE,iBAAA;AAJF;;AAOA;EACE,aAAA;AAJF;;AAOA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,aAAA;AAJF;;AAOA;EACE,eAAA;EACA,kBAAA;AAJF;;AAOA;EACE,eAAA;AAJF;;AAOA;EACE,aC9TW;ED+TX,iBAAA;EACA,gBAAA;EACA,kBAAA;AAJF;AAME;EACE,kBAAA;EACA,aAAA;EACA,uBAAA;AAJJ;AAOE;EACE,UAAA;AALJ;AAQE;EACE,+BAAA;EACA,kBAAA;AANJ;AASE;EACE,8BAAA;EACA,kBAAA;AAPJ;AAQI;EACE,8BAAA;AANN;;AAWA;EACE,cAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;AARF;;AAYE;EACE,kBAAA;EACA,gBAAA;AATJ","sourcesContent":["/*Copyright (c) 2025 por Tecnologías de Información MALMUR y empresas afiliadas. Todos los derechos reservados.\nEste software es información confidencial y propietaria de Copyright (c) 2025 por Tecnologías de Información MALMUR\n y sus afiliadas. (\"Información Confidencial\"). Usted no puede divulgar dicha Información Confidencial, \n y solo puede usar dicha Información Confidencial de acuerdo con los términos del acuerdo de licencia que celebró con MALMUR.*/\n\n/*Copyright (c) 2025 by Tecnologías de Información MALMUR and affiliated companies. All Rights Reserved.\nThis software is confidential and proprietary information of Copyright (c) 2025 by Tecnologías de Información \nMALMUR and its affiliates. (\"Confidential Information\"). You may not disclose such Confidential Information, \nand may only use such Confidential Information in accordance with the terms of the license agreement you entered \ninto with MALMUR.*/\n\n@use \"../_variables\" as vars;\n\n.notification-widget {\n  max-width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  padding-left: 0;\n  padding-right: 0;\n  &--light {\n    border-radius: 24px;\n    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);\n    background: linear-gradient(145deg, #ffffff 0%, #f8fafc 100%);\n  }\n}\n\n.notification-widget-header {\n  padding: vars.$padding-lg;\n  border-top-left-radius: 12px;\n  border-top-right-radius: 12px;\n  &--light {\n    background: linear-gradient(135deg, #1a1a1a 0%, #2d2d2d 100%);\n    color: #ffffff;\n    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);\n  }\n  &--dark {\n    background: linear-gradient(135deg, #2d2d2d 0%, #1a1a1a 100%);\n    color: #ffffff;\n  }\n}\n\n.notification-widget-header-title {\n  font-size: vars.$text-base !important;\n  font-weight: vars.$font-bold !important;\n  &--light {\n    color: #ffffff;\n  }\n}\n\n.notification-widget-header-badge {\n  &--light .MuiBadge-badge {\n    background-color: #ff4757;\n    color: white;\n    font-weight: 600;\n  }\n}\n\n.notification-widget-header-icon {\n  &--light {\n    color: #ffffff !important;\n  }\n}\n\n.notification-widget-header-button {\n  font-size: vars.$text-xs !important;\n  &--light {\n    color: #ffffff;\n    border-color: rgba(255, 255, 255, 0.3);\n    background-color: rgba(255, 255, 255, 0.1);\n    &:hover {\n      background-color: rgba(255, 255, 255, 0.2);\n      border-color: rgba(255, 255, 255, 0.5);\n    }\n  }\n  &--dark {\n    color: white;\n    border-color: rgba(255, 255, 255, 0.3);\n    background-color: rgba(0, 0, 0, 0.1);\n    &:hover {\n      background-color: rgba(0, 0, 0, 0.2);\n      border-color: rgba(255, 255, 255, 0.5);\n    }\n  }\n}\n\n.notification-widget-header-caption {\n  font-size: vars.$text-sm !important;\n  font-weight: vars.$font-medium !important;\n  &--light {\n    color: #ffffff;\n    opacity: 1;\n  }\n  &--dark {\n    color: #ffffff;\n    opacity: 0.9;\n  }\n}\n\n.notification-widget-stats-box {\n  margin-top: 16px;\n  display: flex;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n.notification-widget-toggle-read {\n  &:focus,\n  &:focus-visible,\n  &:active {\n    background-color: rgba(128, 128, 128, 0.1) !important;\n    outline: none !important;\n  }\n  font-size: vars.$text-sm !important;\n}\n\n.notification-widget-stats-chip {\n  font-weight: 600 !important;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  &:hover {\n    transform: scale(1.05);\n    opacity: 0.9;\n  }\n  &--active {\n    border: 2.5px solid #575757 !important;\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.12);\n    z-index: 1;\n  }\n  &--total-light {\n    background-color: rgba(201, 201, 201, 0.59) !important;\n    color: #000000 !important;\n    .MuiChip-label {\n      color: #000000 !important;\n    }\n    &.notification-widget-stats-chip--active {\n      background-color: rgba(201, 201, 201, 0.9) !important;\n      border: 2.5px solid #000000 !important;\n    }\n  }\n  &--total-dark {\n    background-color: #1a2535 !important;\n    color: #ffffff !important;\n    .MuiChip-label {\n      color: #ffffff !important;\n    }\n    &.notification-widget-stats-chip--active {\n      background-color: rgba(255, 255, 255, 0.158) !important;\n      border: 2.5px solid #fff !important;\n    }\n  }\n  &--unread-light {\n    background-color: #ff3546 !important;\n    color: #000000 !important;\n    .MuiChip-label {\n      color: #000000 !important;\n    }\n    &.notification-widget-stats-chip--active {\n      background-color: #ea3030 !important;\n      border: 2.5px solid #000000 !important;\n    }\n  }\n  &--unread-dark {\n    background-color: #710800 !important;\n    color: #ffffff !important;\n    .MuiChip-label {\n      color: #ffffff !important;\n    }\n    &.notification-widget-stats-chip--active {\n      background-color: #7a4542 !important;\n      border: 2.5px solid #fff !important;\n    }\n  }\n  &--read-light {\n    background-color: rgba(82, 205, 87, 0.8) !important;\n    color: #000000 !important;\n    .MuiChip-label {\n      color: #000000 !important;\n    }\n    &.notification-widget-stats-chip--active {\n      background-color: rgb(116, 248, 121) !important;\n      border: 2.5px solid #000000 !important;\n    }\n  }\n  &--read-dark {\n    background-color: #2a80309b !important;\n    color: #ffffff !important;\n    .MuiChip-label {\n      color: #ffffff !important;\n    }\n    &.notification-widget-stats-chip--active {\n      background-color: #69bc6f9b !important;\n      border: 2.5px solid #fff !important;\n    }\n  }\n}\n\n.notification-widget-item {\n  cursor: pointer;\n  border-radius: 8px;\n  margin-top: 8px;\n  margin-bottom: 8px;\n  margin-left: vars.$padding-md;\n  margin-right: vars.$padding-md !important;\n  transition: all 0.2s ease;\n  \n  &.MuiListItem-root {\n    padding-top: vars.$padding-md !important;\n    padding-bottom: vars.$padding-md !important;\n    padding-left: vars.$padding-md !important;\n    padding-right: vars.$padding-xl !important;\n    margin-right: vars.$padding-md !important;\n  }\n\n  .MuiListItemText-root {\n    padding-right: vars.$padding-md !important;\n  }\n  &--read {\n    opacity: 0.6;\n  }\n  &--unread {\n    opacity: 1;\n  }\n  &:hover {\n    opacity: 1;\n  }\n}\n\n.notification-widget-title {\n  flex-grow: 1;\n  font-size: vars.$text-md !important;\n  &--read {\n    font-weight: normal;\n  }\n  &--unread {\n    font-weight: bold !important;\n  }\n}\n\n.notification-widget-message {\n  margin-bottom: 4px;\n  font-size: vars.$text-md !important;\n}\n.notification-widget-date {\n  font-size: vars.$text-xs !important;\n  opacity: 0.7;\n}\n.notification-widget-divider {\n  margin-top: 24px;\n  margin-bottom: 20px;\n  border: 0;\n  border-top: 6px solid rgba(0,0,0,0.18);\n  position: relative;\n  width: 100%;\n  z-index: 0;\n\n  &--read {\n    margin-bottom: 20px;\n  }\n  &--unread {\n    margin-top: 24px;\n    margin-bottom: 20px;\n  }\n}\n\n.notification-widget--light .notification-widget-divider {\n  border-top: 6px solid #1a1a1a !important;\n}\n.notification-widget--dark .notification-widget-divider {\n  border-top: 6px solid rgba(255,255,255,0.22) !important;\n}\n\n.notification-widget-divider-chip {\n  display: flex !important;\n  justify-content: center !important;\n  align-items: center !important;\n  margin: 12px 0 20px 0 !important;\n  width: 100% !important;\n\n  .MuiChip-root {\n    display: inline-flex !important;\n    background: none !important;\n  }\n}\n\n.notification-widget-item {\n  margin-top: 8px;\n}\n\n\n.notification-widget-chip {\n  opacity: 1 !important;\n  font-size: 0.85rem !important;\n  font-weight: 700 !important;\n  background-color: transparent !important;\n  align-self: center !important;\n  align-content: center !important;\n  &--read .MuiChip-label {\n    color: #4caf50 !important;\n  }\n  \n  &--unread .MuiChip-label {\n    color: #ff4757 !important;\n  }\n  \n  &.MuiChip-label--light .MuiChip-label {\n    color: #909090 !important;\n  }\n  \n  &.MuiChip-label--dark .MuiChip-label {\n    color: #ffffff !important;\n  }\n}\n\n.notification-widget-loading {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 32px;\n}\n\n.notification-widget-loading-text {\n  margin-left: 16px;\n}\n\n.notification-widget-error {\n  padding: 16px;\n}\n\n.notification-widget-empty {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 32px;\n}\n\n.notification-widget-empty-icon {\n  font-size: 48px;\n  margin-bottom: 8px;\n}\n\n.notification-widget-empty-caption {\n  margin-top: 8px;\n}\n\n.notification-widget-list {\n  padding: vars.$padding-md;\n  max-height: 675px;\n  overflow-y: auto;\n  overflow-x: hidden;\n  \n  .notification-widget-divider-chip {\n    text-align: center;\n    display: flex;\n    justify-content: center;\n  }\n  \n  &::-webkit-scrollbar {\n    width: 8px;\n  }\n  \n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 4px;\n  }\n  \n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 4px;\n    &:hover {\n      background: rgba(0, 0, 0, 0.3);\n    }\n  }\n}\n\n.notification-widget-content {\n  flex: 1 1 auto;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n}\n\n.notification-widget-snackbar {\n  .MuiSnackbarContent-root {\n    border-radius: 8px;\n    font-weight: 500;\n  }\n}\n\n","/*Copyright (c) 2025 por Tecnologías de Información MALMUR y empresas afiliadas. Todos los derechos reservados.\nEste software es información confidencial y propietaria de Copyright (c) 2025 por Tecnologías de Información MALMUR\n y sus afiliadas. (\"Información Confidencial\"). Usted no puede divulgar dicha Información Confidencial, \n y solo puede usar dicha Información Confidencial de acuerdo con los términos del acuerdo de licencia que celebró con MALMUR.*/\n\n/*Copyright (c) 2025 by Tecnologías de Información MALMUR and affiliated companies. All Rights Reserved.\nThis software is confidential and proprietary information of Copyright (c) 2025 by Tecnologías de Información \nMALMUR and its affiliates. (\"Confidential Information\"). You may not disclose such Confidential Information, \nand may only use such Confidential Information in accordance with the terms of the license agreement you entered \ninto with MALMUR.*/\n\n//colors\n$color-black: #000;\n$color-white: #fff;\n$color-gray-light: #f5f5f5;\n$color-gray-dark: #717171;\n$dark-form-backcolor: #1e1532;\n$light-form-backcolor: #ffffff;\n\n//media query\n$xs-media-querys: 320px;\n$sm-media-querys: 768px;\n$md-media-querys: 1024px;\n$lg-media-querys: 1440px;\n\n// Padding variables - Sistema uniforme de espaciado\n$padding-xs: 8px;\n$padding-sm: 12px;\n$padding-md: 16px;\n$padding-lg: 24px;\n$padding-xl: 32px;\n\n// Typography sizes - Tamaños uniformes de texto\n$text-xs: 0.75rem; // 12px - Captions, labels pequeños\n$text-sm: 0.875rem; // 14px - Body text pequeño\n$text-md: 0.9375rem; // 15px - Body text mediano\n$text-base: 1rem; // 16px - Body text normal\n$text-lg: 1.125rem; // 18px - Body text grande\n$text-xl: 1.25rem; // 20px - Subtítulos pequeños\n$text-2xl: 1.5rem; // 24px - Subtítulos\n$text-3xl: 1.875rem; // 30px - Títulos\n$text-4xl: 2.25rem; // 36px - Títulos grandes\n\n// Font weights\n$font-normal: 400;\n$font-medium: 500;\n$font-semibold: 600;\n$font-bold: 700;\n\n// Border radius\n$border-radius-sm: 0.25rem; // 4px\n$border-radius-md: 0.5rem; // 8px\n$border-radius-lg: 1rem; // 16px"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
